__turbopack_context__.v({
  "ouro-logo": "OuroLogoWithTagline-module-scss-module__I_esBa__ouro-logo",
});
